// removed by extract-text-webpack-plugin
module.exports = {"BoxContainer":"purify_Box__BoxContainer___3cEy4","Box":"purify_Box__Box___2jRvJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/Box.scss
// module id = 243
// module chunks = 0